import { render, staticRenderFns } from "./ProductStockMonthlyClosing.vue?vue&type=template&id=dfb089a6&scoped=true&"
import script from "./ProductStockMonthlyClosing.vue?vue&type=script&lang=js&"
export * from "./ProductStockMonthlyClosing.vue?vue&type=script&lang=js&"
import style0 from "./ProductStockMonthlyClosing.vue?vue&type=style&index=0&id=dfb089a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb089a6",
  null
  
)

export default component.exports